import { defineComponent as _defineComponent } from 'vue';
import { BTable } from "bootstrap-vue";
import { computed } from "vue";
import { DESCRIPTION_FIELD, NAME_FIELD, TEMPLATE_FIELD, TYPE_FIELD } from "@/components/ConfigTemplates/fields";
import { useFiltering } from "@/components/ConfigTemplates/useInstanceFiltering";
import { useFileSourceInstancesStore } from "@/stores/fileSourceInstancesStore";
import InstanceDropdown from "./InstanceDropdown.vue";
import ManageIndexHeader from "@/components/ConfigTemplates/ManageIndexHeader.vue";
import FileSourceTypeSpan from "@/components/FileSources/FileSourceTypeSpan.vue";
import TemplateSummarySpan from "@/components/FileSources/Templates/TemplateSummarySpan.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ManageIndex',
    props: {
        message: null
    },
    setup(__props) {
        const fileSourceInstancesStore = useFileSourceInstancesStore();
        const fields = [NAME_FIELD, DESCRIPTION_FIELD, TYPE_FIELD, TEMPLATE_FIELD];
        const allItems = computed(() => fileSourceInstancesStore.getInstances);
        const { activeInstances } = useFiltering(allItems);
        const loading = computed(() => fileSourceInstancesStore.loading);
        fileSourceInstancesStore.fetchInstances();
        function reload() {
            fileSourceInstancesStore.fetchInstances();
        }
        return { __sfc: true, fileSourceInstancesStore, fields, allItems, activeInstances, loading, reload, BTable, InstanceDropdown, ManageIndexHeader, FileSourceTypeSpan, TemplateSummarySpan, LoadingSpan };
    }
});
